const { JisonParser, o } = require('@ts-jison/parser');
/**
 * parser generated by  @ts-jison/parser-generator 0.4.1-aytm.3
 * @returns Parser implementing JisonParserApi and a Lexer implementing JisonLexerApi.
 */
class StatParser extends JisonParser {
    constructor(yy = {}, lexer = new StatLexer(yy)) {
        super(yy, lexer);
        this.symbols_ = {"error":2,"expressions":3,"statement":4,"EOF":5,"e":6,"LPAREN":7,"RPAREN":8,"BOOLEAN":9,"BREF":10,"AND":11,"OR":12,"NOT":13,"SEEN":14,"bref":15,"ne":16,"LE":17,"GE":18,"LT":19,"GT":20,"token":21,"EQ":22,"te":23,"NEQ":24,"list":25,"IN":26,"NOT_IN":27,"LIKE":28,"codeBook":29,"str_list":30,"tag":31,"tag_path":32,"IN_SHAPE":33,"IN_SECTION":34,"ERROR":35,"TAG":36,"DOT":37,"TOKEN":38,"tag_path_list":39,"COMMA":40,"CODEBOOK":41,"NUMBER":42,"NREF":43,"NTRAIT":44,"NTOKEN":45,"ISODATE":46,"SUB":47,"ADD":48,"MLT":49,"DIV":50,"MIN":51,"MAX":52,"MINPOSITION":53,"MAXPOSITION":54,"COUNT":55,"STR":56,"te_repetition_plus0":57,"TREF":58,"TRAIT":59,"str_list_repetition_plus0":60,"arrayref":61,"ARRAYREF":62,"ATRAIT":63,"ATOKEN":64,"$accept":0,"$end":1};
        this.terminals_ = {2:"error",5:"EOF",7:"LPAREN",8:"RPAREN",9:"BOOLEAN",10:"BREF",11:"AND",12:"OR",13:"NOT",14:"SEEN",17:"LE",18:"GE",19:"LT",20:"GT",22:"EQ",24:"NEQ",26:"IN",27:"NOT_IN",28:"LIKE",33:"IN_SHAPE",34:"IN_SECTION",35:"ERROR",36:"TAG",37:"DOT",38:"TOKEN",40:"COMMA",41:"CODEBOOK",42:"NUMBER",43:"NREF",44:"NTRAIT",45:"NTOKEN",46:"ISODATE",47:"SUB",48:"ADD",49:"MLT",50:"DIV",51:"MIN",52:"MAX",53:"MINPOSITION",54:"MAXPOSITION",55:"COUNT",56:"STR",58:"TREF",59:"TRAIT",62:"ARRAYREF",63:"ATRAIT",64:"ATOKEN"};
        this.productions_ = [0,[3,2],[4,1],[6,3],[6,1],[6,1],[6,3],[6,3],[6,2],[6,2],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,3],[6,4],[6,4],[6,4],[6,4],[6,3],[6,3],[6,3],[6,4],[6,4],[6,4],[6,4],[6,4],[6,4],[6,4],[6,4],[6,4],[6,3],[6,3],[6,3],[6,1],[31,1],[31,3],[32,3],[32,1],[39,3],[39,3],[29,1],[15,1],[16,3],[16,1],[16,1],[16,1],[16,1],[16,1],[16,2],[16,3],[16,3],[16,3],[16,3],[16,3],[16,3],[16,3],[16,3],[16,2],[16,2],[16,2],[16,2],[16,2],[23,3],[23,2],[23,1],[23,1],[23,1],[23,3],[23,3],[23,3],[21,3],[21,1],[30,3],[30,2],[30,1],[30,3],[61,1],[25,3],[25,1],[25,1],[25,1],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[25,3],[57,1],[57,2],[60,1],[60,2]];

        // shorten static method to just `o` for terse STATE_TABLE
        const $V0=[1,4],$V1=[1,5],$V2=[1,6],$V3=[1,7],$V4=[1,8],$V5=[1,15],$V6=[1,35],$V7=[1,27],$V8=[1,34],$V9=[1,16],$Va=[1,17],$Vb=[1,18],$Vc=[1,19],$Vd=[1,20],$Ve=[1,21],$Vf=[1,22],$Vg=[1,23],$Vh=[1,24],$Vi=[1,25],$Vj=[1,26],$Vk=[1,28],$Vl=[1,29],$Vm=[1,30],$Vn=[1,33],$Vo=[1,31],$Vp=[1,32],$Vq=[1,37],$Vr=[1,38],$Vs=[5,8,11,12],$Vt=[1,49],$Vu=[1,50],$Vv=[1,51],$Vw=[1,52],$Vx=[1,53],$Vy=[1,54],$Vz=[1,55],$VA=[1,56],$VB=[1,57],$VC=[1,58],$VD=[1,63],$VE=[1,60],$VF=[1,59],$VG=[1,61],$VH=[1,62],$VI=[1,64],$VJ=[1,65],$VK=[1,66],$VL=[1,67],$VM=[1,68],$VN=[1,69],$VO=[1,70],$VP=[1,71],$VQ=[1,72],$VR=[1,74],$VS=[1,73],$VT=[1,75],$VU=[1,76],$VV=[1,77],$VW=[1,78],$VX=[1,79],$VY=[1,81],$VZ=[1,80],$V_=[1,82],$V$=[1,83],$V01=[1,84],$V11=[1,85],$V21=[1,86],$V31=[1,87],$V41=[1,96],$V51=[5,8,11,12,17,18,19,20,22,24,26,27,28,33,40,47,48,49,50],$V61=[1,100],$V71=[1,102],$V81=[7,10,22,24,26],$V91=[1,116],$Va1=[1,117],$Vb1=[1,118],$Vc1=[1,119],$Vd1=[1,127],$Ve1=[1,128],$Vf1=[2,100],$Vg1=[1,131],$Vh1=[1,141],$Vi1=[1,181],$Vj1=[8,22,24,26],$Vk1=[5,8,11,12,17,18,19,20,22,24,26,27,28,33,40,47,48,49,50,56],$Vl1=[1,250],$Vm1=[5,8,11,12,40],$Vn1=[5,8,11,12,17,18,19,20,22,24,26,27,28,33,40,47,48],$Vo1=[5,8,11,12,17,18,19,20,22,24,26,27,28,33,40],$Vp1=[5,8,11,12,17,18,19,20,22,24,26,27,28,33,40,47,49,50],$Vq1=[5,8,11,12,40,56],$Vr1=[8,22,24,26,40];
        const o = JisonParser.expandParseTable;
        this.table = [{3:1,4:2,6:3,7:$V0,9:$V1,10:$V2,13:$V3,14:$V4,16:9,21:10,23:11,25:12,29:13,31:14,35:$V5,36:$V6,38:$V7,41:$V8,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{1:[3]},{5:[1,36]},{5:[2,2],11:$Vq,12:$Vr},{6:39,7:$V0,9:$V1,10:$V2,13:$V3,14:$V4,16:40,21:41,23:42,25:43,29:13,31:14,35:$V5,36:$V6,38:$V7,41:$V8,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},o($Vs,[2,4]),o($Vs,[2,5],{29:44,31:45,34:[1,46],36:$V6,41:$V8}),{6:47,7:$V0,9:$V1,10:$V2,13:$V3,14:$V4,16:9,21:10,23:11,25:12,29:13,31:14,35:$V5,36:$V6,38:$V7,41:$V8,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{10:$Vt,15:48},{17:$Vu,18:$Vv,19:$Vw,20:$Vx,22:$Vy,24:$Vz,26:$VA,27:$VB,28:$VC,40:$VD,47:$VE,48:$VF,49:$VG,50:$VH},{17:$VI,18:$VJ,19:$VK,20:$VL,22:$VM,24:$VN,26:$VO,27:$VP,28:$VQ,40:$VR,48:$VS},{22:$VT,24:$VU,26:$VV,27:$VW,28:$VX,40:$VY,48:$VZ},{22:$V_,24:$V$,26:$V01,27:$V11,33:$V21,40:$V31},{10:[1,90],22:[1,88],26:[1,89]},{7:$V41,10:[1,94],15:98,22:[1,91],24:[1,92],26:[1,93],32:95,39:97},o($Vs,[2,92]),o($V51,[2,102]),o($V51,[2,103]),o($V51,[2,104]),o($V51,[2,105]),o($V51,[2,106]),{7:$V61,16:99,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$V71,16:103,21:105,23:104,25:101,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:104,25:106,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:104,25:107,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:104,25:108,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:104,25:109,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},o($V51,[2,130]),o($V51,[2,123],{57:110,56:[1,111]}),o($V51,[2,124]),o($V51,[2,125]),o($V51,[2,137]),o($V51,[2,138]),o($V51,[2,139]),o([10,22,26],[2,99]),o($V81,[2,93],{37:[1,112]}),{1:[2,1]},{6:113,7:$V0,9:$V1,10:$V2,13:$V3,14:$V4,16:9,21:10,23:11,25:12,29:13,31:14,35:$V5,36:$V6,38:$V7,41:$V8,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{6:114,7:$V0,9:$V1,10:$V2,13:$V3,14:$V4,16:9,21:10,23:11,25:12,29:13,31:14,35:$V5,36:$V6,38:$V7,41:$V8,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{8:[1,115],11:$Vq,12:$Vr},{8:$V91,17:$Vu,18:$Vv,19:$Vw,20:$Vx,22:$Vy,24:$Vz,26:$VA,27:$VB,28:$VC,40:$VD,47:$VE,48:$VF,49:$VG,50:$VH},{8:$Va1,17:$VI,18:$VJ,19:$VK,20:$VL,22:$VM,24:$VN,26:$VO,27:$VP,28:$VQ,40:$VR,48:$VS},{8:$Vb1,22:$VT,24:$VU,26:$VV,27:$VW,28:$VX,40:$VY,48:$VZ},{8:$Vc1,22:$V_,24:$V$,26:$V01,27:$V11,33:$V21,40:$V31},{22:[1,120],26:[1,121]},{22:[1,122],24:[1,123],26:[1,124]},{7:$Vd1,10:[1,126],30:125,56:$Ve1},o($Vs,[2,8]),o($Vs,[2,9]),o([5,8,11,12,22,24,26,40],$Vf1),{7:$Vg1,16:129,21:130,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vg1,16:132,21:133,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vg1,16:134,21:135,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vg1,16:136,21:137,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vh1,16:138,21:140,23:139,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm},{7:$Vh1,16:142,21:144,23:143,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm},{7:$V71,16:103,21:105,23:146,25:145,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:148,25:147,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$Vg1,16:149,21:150,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vg1,16:151,21:152,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vg1,16:153,21:154,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vg1,16:155,21:156,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$Vg1,16:157,21:158,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$V71,16:159,21:161,23:160,25:162,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V61,16:163,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$V61,16:164,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$V61,16:165,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{7:$V61,16:166,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},{6:170,7:$V0,9:$V1,10:$V2,13:$V3,14:$V4,16:167,21:169,23:168,25:171,29:13,31:14,35:$V5,36:$V6,38:$V7,41:$V8,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:172,21:174,23:173,25:175,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:177,25:176,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:179,25:178,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$Vi1,21:182,23:180,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vi1,21:182,23:183,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$V71,16:185,21:184,23:186,25:187,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:189,21:190,23:188,25:191,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:193,21:194,23:192,25:195,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:197,25:196,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:199,25:198,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$Vh1,16:201,21:202,23:200,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm},{7:$Vi1,21:204,23:203,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$V71,16:206,21:207,23:205,25:208,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:209,23:211,25:210,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:212,23:214,25:213,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:104,25:215,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$V71,16:103,21:105,23:104,25:216,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$Vd1,30:217,56:$Ve1},{7:$V71,16:218,21:220,23:219,25:221,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{7:$Vi1,21:182,23:222,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vd1,30:223,56:$Ve1},{22:[1,224],26:[1,225]},{7:$Vi1,21:182,23:226,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vi1,21:182,23:227,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vd1,30:228,56:$Ve1},{22:[1,229],24:[1,230],26:[1,231],40:$Vf1},{22:[1,232],24:[1,233],26:[1,234]},{7:$V41,10:$Vt,15:98,32:235,39:97},o($Vj1,[2,96],{40:[1,236]}),{40:[1,237]},o($V51,[2,107]),{7:$V61,16:238,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},o($V51,[2,116]),{7:$V71,16:240,21:242,23:241,25:239,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm,62:$Vn,63:$Vo,64:$Vp},{40:$VD,47:$VE,48:$VF,49:$VG,50:$VH},{40:$VY,48:$VZ},{40:$VR,48:$VS},o($V51,[2,117]),o($V51,[2,118]),o($V51,[2,119]),o($V51,[2,120]),o($V51,[2,122],{56:[1,243]}),o($Vk1,[2,156]),{38:[1,244]},o($Vs,[2,6]),o($Vs,[2,7]),o($Vs,[2,3]),o($V51,[2,101]),o($V51,[2,129]),o($V51,[2,121]),o($V51,[2,136]),{7:$Vi1,21:182,23:245,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vd1,30:246,56:$Ve1},{7:$Vi1,21:182,23:247,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vi1,21:182,23:248,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vd1,30:249,56:$Ve1},o($Vs,[2,90],{40:$Vl1}),o($Vs,[2,91]),{7:$Vd1,30:251,56:$Ve1},o($Vm1,[2,133],{60:252,56:[1,253]}),o($Vs,[2,10],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,18]),{7:$Vg1,16:238,21:254,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj},o($Vs,[2,11],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,19]),o($Vs,[2,12],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,20]),o($Vs,[2,13],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,21]),o($Vs,[2,22],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,25],{48:$VZ}),o($Vs,[2,30],{48:$VS}),{7:$Vh1,16:238,21:256,23:255,38:$V7,42:$V9,43:$Va,44:$Vb,45:$Vc,46:$Vd,47:$Ve,51:$Vf,52:$Vg,53:$Vh,54:$Vi,55:$Vj,56:$Vk,58:$Vl,59:$Vm},o($Vs,[2,26],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,29],{48:$VZ}),o($Vs,[2,36],{48:$VS}),o($Vs,[2,52],{40:$V31}),o($Vs,[2,55],{40:$VY,48:$VZ}),o($Vs,[2,59],{40:$V31}),o($Vs,[2,62],{40:$VY,48:$VZ}),o($Vs,[2,67],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,69]),o($Vn1,[2,108],{49:$VG,50:$VH}),o($V51,[2,112]),o($Vn1,[2,109],{49:$VG,50:$VH}),o($V51,[2,113]),o($V51,[2,110]),o($V51,[2,114]),o($V51,[2,111]),o($V51,[2,115]),o($Vo1,[2,140],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vp1,[2,141],{48:$VZ}),o($Vp1,[2,142],{48:$VS}),o($V51,[2,143]),o($Vs,[2,14],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,15],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,16],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,17],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,32],{17:$Vu,18:$Vv,19:$Vw,20:$Vx,22:$Vy,24:$Vz,26:$VA,27:$VB,28:$VC,40:$VD,47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,33],{22:$VT,24:$VU,26:$VV,27:$VW,28:$VX,40:$VY,48:$VZ}),o($Vs,[2,34],{17:$VI,18:$VJ,19:$VK,20:$VL,22:$VM,24:$VN,26:$VO,27:$VP,28:$VQ,40:$VR,48:$VS}),o($Vs,[2,35]),o($Vs,[2,43],{22:$V_,24:$V$,26:$V01,27:$V11,33:$V21,40:$V31}),o($Vs,[2,38],{40:$VD,47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,39],{40:$VY,48:$VZ}),o($Vs,[2,40],{40:$VR,48:$VS}),o($Vs,[2,44],{40:$V31}),o($Vs,[2,54],{40:$V31}),o($Vs,[2,57],{40:$VY,48:$VZ}),o($Vs,[2,61],{40:$V31}),o($Vs,[2,64],{40:$VY,48:$VZ}),o($Vs,[2,70],{48:$VZ}),{7:$Vi1,21:256,23:255,38:$V7,56:$Vk,58:$Vl,59:$Vm},{48:$VS},o($V51,[2,128]),o($Vp1,[2,148],{48:$VS}),o($Vo1,[2,149],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vp1,[2,150],{48:$VZ}),o($V51,[2,151]),o($Vs,[2,23],{40:$VY,48:$VZ}),o($Vs,[2,24],{40:$VD,47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,31],{40:$VR,48:$VS}),o($Vs,[2,49],{40:$V31}),o($Vs,[2,27],{40:$VY,48:$VZ}),o($Vs,[2,28],{40:$VD,47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,37],{40:$VR,48:$VS}),o($Vs,[2,50],{40:$V31}),o($Vs,[2,53],{40:$V31}),o($Vs,[2,56],{40:$VY,48:$VZ}),o($Vs,[2,60],{40:$V31}),o($Vs,[2,63],{40:$VY,48:$VZ}),o($Vs,[2,65],{48:$VZ}),o($Vs,[2,66],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vs,[2,68],{48:$VS}),o($V51,[2,126]),o($V51,[2,127]),o($Vp1,[2,144],{48:$VZ}),o($Vo1,[2,145],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vp1,[2,146],{48:$VS}),o($V51,[2,147]),o($Vs,[2,41],{40:$VR,48:$VS}),o($Vs,[2,45],{40:$V31}),o($Vs,[2,47],{40:$VY,48:$VZ}),o($Vs,[2,42],{40:$VR,48:$VS}),o($Vs,[2,46],{40:$V31}),o($Vs,[2,48],{40:$VY,48:$VZ}),o($Vs,[2,51],{40:$V31}),o($Vs,[2,58],{40:$V31}),o($Vs,[2,89],{40:$Vl1}),o($Vo1,[2,152],{47:$VE,48:$VF,49:$VG,50:$VH}),o($Vp1,[2,153],{48:$VZ}),o($Vp1,[2,154],{48:$VS}),o($V51,[2,155]),o($Vs,[2,71],{48:$VZ}),o($Vs,[2,72],{40:$Vl1}),{7:$Vi1,21:182,23:257,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vd1,30:258,56:$Ve1},o($Vs,[2,77],{48:$VZ}),o($Vs,[2,78],{48:$VZ}),o($Vs,[2,79],{40:$Vl1}),{7:$Vi1,21:182,23:259,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vi1,21:182,23:260,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vd1,30:261,56:$Ve1},{7:$Vi1,21:182,23:262,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vi1,21:182,23:263,38:$V7,56:$Vk,58:$Vl,59:$Vm},{7:$Vd1,30:264,56:$Ve1},{8:[1,265]},{10:$Vt,15:266},{10:$Vt,15:267},{8:$V91,47:$VE,48:$VF,49:$VG,50:$VH},{8:$Vc1,40:$V31},{8:$V91,40:$VD,47:$VE,48:$VF,49:$VG,50:$VH},{8:$Vb1,40:$VY,48:$VZ},{8:$Va1,40:$VR,48:$VS},o($Vk1,[2,157]),o($V81,[2,94]),o($Vs,[2,73],{48:$VZ}),o($Vs,[2,74],{40:$Vl1}),o($Vs,[2,80],{48:$VZ}),o($Vs,[2,81],{48:$VZ}),o($Vs,[2,82],{40:$Vl1}),{7:$Vd1,30:268,56:$Ve1},{8:[1,269],40:$Vl1},o($Vm1,[2,132],{56:[1,270]}),o($Vq1,[2,158]),{8:$Va1},{8:$Vb1,48:$VZ},{8:$Va1,48:$VS},o($Vs,[2,75],{48:$VZ}),o($Vs,[2,76],{40:$Vl1}),o($Vs,[2,83],{48:$VZ}),o($Vs,[2,84],{48:$VZ}),o($Vs,[2,85],{40:$Vl1}),o($Vs,[2,86],{48:$VZ}),o($Vs,[2,87],{48:$VZ}),o($Vs,[2,88],{40:$Vl1}),o($Vj1,[2,95]),o($Vr1,[2,98]),o($Vr1,[2,97]),o($Vm1,[2,134]),o($Vm1,[2,131]),o($Vq1,[2,159])];
        this.defaultActions = {36:[2,1]};
    }
    performAction (yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */
          const $0 = $$.length - 1;
        switch (yystate) {
case 1:
return $$[$0-1]
break;
case 2: case 96:
this.$ = $$[$0];
break;
case 3: case 95: case 101: case 121: case 129: case 131: case 136:
this.$ = $$[$0-1];
break;
case 4:
this.$ = { type: 'Literal', value: 'TRUE' === $$[$0].toUpperCase() }
break;
case 5: case 100:
this.$ = yy.saveRef({alias: $$[$0], type: 'ref', subtype: 'bref', default: false, location: this._$ });
break;
case 6:
this.$ = { type: 'LogicalExpression', operator: '&&', left: $$[$0-2], right: $$[$0] };
break;
case 7:
this.$ = { type: 'LogicalExpression', operator: '||', left: $$[$0-2], right: $$[$0] };
break;
case 8:
this.$ = { type: 'UnaryExpression', operator: '!', prefix: true, argument: $$[$0] };
break;
case 9:
this.$ = { type: 'UnaryExpression', operator: 'seen', prefix: true, argument: $$[$0] };
break;
case 10: case 14: case 18:
this.$ = { type: 'BinaryExpression', operator: '<=', left: $$[$0-2], right: $$[$0] };
break;
case 11: case 15: case 19:
this.$ = { type: 'BinaryExpression', operator: '>=', left: $$[$0-2], right: $$[$0] };
break;
case 12: case 16: case 20:
this.$ = { type: 'BinaryExpression', operator: '<', left: $$[$0-2], right: $$[$0] };
break;
case 13: case 17: case 21:
this.$ = { type: 'BinaryExpression', operator: '>', left: $$[$0-2], right: $$[$0] };
break;
case 22: case 23: case 24: case 25: case 30: case 31: case 32: case 33: case 34: case 35: case 41: case 43: case 45: case 47: case 49:
this.$ = { type: 'BinaryExpression', operator: '==', left: $$[$0-2], right: $$[$0] };
break;
case 26: case 27: case 28: case 29: case 36: case 37: case 38: case 39: case 40: case 42: case 44: case 46: case 48: case 50:
this.$ = { type: 'BinaryExpression', operator: '!=', left: $$[$0-2], right: $$[$0] };
break;
case 51: case 52: case 53: case 54: case 55: case 56: case 57: case 58:
this.$ = { type: 'BinaryExpression', operator: 'in', left: $$[$0-2], right: $$[$0] };
break;
case 59: case 60: case 61: case 62: case 63: case 64:
this.$ = { type: 'BinaryExpression', operator: 'not_in', left: $$[$0-2], right: $$[$0] };
break;
case 65: case 66: case 67: case 68: case 69: case 70:
this.$ = { type: 'BinaryExpression', operator: 'like', left: $$[$0-2], right: $$[$0] };
break;
case 71:
this.$ = { type: 'BinaryExpression', operator: 'codebook_eq', left: $$[$0-2], right: yy.saveRef({ type: 'codebook', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 72:
this.$ = { type: 'BinaryExpression', operator: 'codebook_in', left: $$[$0-2], right: yy.saveRef({ type: 'codebook', subtype: 'list', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 73:
this.$ = { type: 'BinaryExpression', operator: 'codebook_eq', scope: [ yy.saveRef({ alias: $$[$0-3], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-2], right: yy.saveRef({ alias: $$[$0-3], type: 'codebook', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 74:
this.$ = { type: 'BinaryExpression', operator: 'codebook_in', scope: [ yy.saveRef({ alias: $$[$0-3], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-2], right: yy.saveRef({ alias: $$[$0-3], type: 'codebook', subtype: 'list', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 75:
this.$ = { type: 'BinaryExpression', operator: 'codebook_eq', scope: [ yy.saveRef({ alias: $$[$0-2], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'codebook', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 76:
this.$ = { type: 'BinaryExpression', operator: 'codebook_in', scope: [ yy.saveRef({ alias: $$[$0-2], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'codebook', subtype: 'list', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 77:
this.$ = { type: 'BinaryExpression', operator: 'tag_eq', left: $$[$0-2], right: yy.saveRef({ type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 78:
this.$ = { type: 'BinaryExpression', operator: 'tag_neq', left: $$[$0-2], right: yy.saveRef({ type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 79:
this.$ = { type: 'BinaryExpression', operator: 'tag_in', left: $$[$0-2], right: yy.saveRef({ type: 'tag', subtype: 'list', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 80:
this.$ = { type: 'BinaryExpression', operator: 'tag_eq', scope: [ yy.saveRef({ alias: $$[$0-3], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-2], right: yy.saveRef({ alias: $$[$0-3], type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 81:
this.$ = { type: 'BinaryExpression', operator: 'tag_neq', scope: [ yy.saveRef({ alias: $$[$0-3], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-2], right: yy.saveRef({ alias: $$[$0-3], type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 82:
this.$ = { type: 'BinaryExpression', operator: 'tag_in', scope: [ yy.saveRef({ alias: $$[$0-3], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-2], right: yy.saveRef({ alias: $$[$0-3], type: 'tag', subtype: 'list', value: $$[$0], location: _$[$0], scope: $$[$0-2] }) };
break;
case 83:
this.$ = { type: 'BinaryExpression', operator: 'tag_eq', scope: [ yy.saveRef({ alias: $$[$0-2], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 84:
this.$ = { type: 'BinaryExpression', operator: 'tag_neq', scope: [ yy.saveRef({ alias: $$[$0-2], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 85:
this.$ = { type: 'BinaryExpression', operator: 'tag_in', scope: [ yy.saveRef({ alias: $$[$0-2], type: 'ref', subtype: 'bref', default: false, location: this._$ }) ], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'tag', subtype: 'list', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 86:
this.$ = { type: 'BinaryExpression', operator: 'tag_eq', scope: $$[$0-2], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 87:
this.$ = { type: 'BinaryExpression', operator: 'tag_neq', scope: $$[$0-2], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'tag', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 88:
this.$ = { type: 'BinaryExpression', operator: 'tag_in', scope: $$[$0-2], left: $$[$0-3], right: yy.saveRef({ alias: $$[$0-2], type: 'tag', subtype: 'list', value: $$[$0], location: _$[$0], scope: $$[$0-3] }) };
break;
case 89:
this.$ = { type: 'BinaryExpression', operator: 'in_shape', left: $$[$0-2], right: yy.saveRef({ alias: $$[$0], type: 'asset', subtype: yy.HEATMAP_CLUSTER, location: _$[$0], scope: $$[$0-2] }) }
break;
case 90:
this.$ = { type: 'BinaryExpression', operator: 'in_section', left: yy.saveRef({alias: $$[$0-2], type: 'ref', subtype: 'bref', default: false, location: _$[$0-2] }), right: $$[$0] }
break;
case 91:
this.$ = { type: 'BinaryExpression', operator: 'in_section', left: yy.saveRef({alias: $$[$0-2], type: 'ref', subtype: 'bref', default: false, location: _$[$0-2] }), right: yy.saveRef({alias: $$[$0], type: 'ref', subtype: 'bref', default: false, location: _$[$0] }) }
break;
case 92:
this.$ = yy.saveRef({ alias: $$[$0], type: 'error', location: this._$ });
break;
case 93:
this.$ = yy.saveRef({alias: $$[$0], type: 'ref', subtype: 'tag', default: '', location: this._$ });
break;
case 94:
this.$ = yy.saveRef({alias: $$[$0-2] + '.' + $$[$0], type: 'ref', subtype: 'tag', default: '', location: this._$ });
break;
case 97: case 98:
this.$ = yy.saveArray($$[$0-2], $$[$0], true);
break;
case 99:
this.$ = yy.saveRef({alias: $$[$0], type: 'ref', subtype: 'codebook', default: '', location: this._$ });
break;
case 102:
this.$ = { type: 'Literal', value: parseFloat($$[$0], 10), raw: $$[$0] };
break;
case 103: case 105:
this.$ = yy.saveRef({ alias: $$[$0], type: 'ref', subtype: 'nref', default: 0, location: this._$ });
break;
case 104:
this.$ = yy.saveRef({ alias: $$[$0], type: 'ntrait', location: this._$ });
break;
case 106:
yy.tmp = yy.normalizeISODate($$[$0]); this.$ = { type: 'Literal', value: new Date(yy.tmp), raw: yy.tmp };
break;
case 107:
this.$ = { type: 'UnaryExpression', operator: '-', prefix: true, argument: $$[$0] };
break;
case 108: case 112: case 126: case 127: case 128:
this.$ = { type: 'BinaryExpression', operator: '+', left: $$[$0-2], right: $$[$0] };
break;
case 109: case 113:
this.$ = { type: 'BinaryExpression', operator: '-', left: $$[$0-2], right: $$[$0] };
break;
case 110: case 114:
this.$ = { type: 'BinaryExpression', operator: '*', left: $$[$0-2], right: $$[$0] };
break;
case 111: case 115:
this.$ = { type: 'BinaryExpression', operator: '/', left: $$[$0-2], right: $$[$0] };
break;
case 116:
this.$ = { type: 'UnaryExpression', operator: 'min', prefix: true, argument: $$[$0] };
break;
case 117:
this.$ = { type: 'UnaryExpression', operator: 'max', prefix: true, argument: $$[$0] };
break;
case 118:
this.$ = { type: 'UnaryExpression', operator: 'minPos', prefix: true, argument: $$[$0] };
break;
case 119:
this.$ = { type: 'UnaryExpression', operator: 'maxPos', prefix: true, argument: $$[$0] };
break;
case 120:
this.$ = { type: 'UnaryExpression', operator: 'count', prefix: true, argument: $$[$0] };
break;
case 122:
this.$ = { type: 'Literal', value: [$$[$0-1]].concat($$[$0]).map(function(v){return yy.removeQuotes(v);}).join(''), raw: [$$[$0-1]].concat($$[$0]).join('') };
break;
case 123: case 133:
this.$ = { type: 'Literal', value: yy.removeQuotes($$[$0]), raw: $$[$0] };
break;
case 124: case 130:
this.$ = yy.saveRef({alias: $$[$0], type: 'ref', subtype: 'tref', default: '', location: this._$ });
break;
case 125:
this.$ = yy.saveRef({alias: $$[$0], type: 'trait', location: this._$ });
break;
case 132:
this.$ = { type: 'Literal', value: [$$[$0-1]].concat($$[$0]).map(v => yy.removeQuotes(v)).join(''), raw: [$$[$0-1]].concat($$[$0]).join('') };
break;
case 134: case 140: case 141: case 142: case 143: case 144: case 145: case 146: case 147: case 148: case 149: case 150: case 151: case 152: case 153: case 154: case 155:
this.$ = yy.saveArray($$[$0-2], $$[$0]);
break;
case 135: case 139:
this.$ = yy.saveRef({alias: $$[$0], type: 'ref', subtype: 'aref', default: [], location: this._$ });
break;
case 137:
this.$ = yy.saveRef({alias: $$[$0], type: 'atrait', default: [], location: this._$ });
break;
case 138:
this.$ = yy.saveRef({ alias: $$[$0], type: 'ref', subtype: 'aref', default: [], location: this._$ });
break;
case 156: case 158:
this.$ = [$$[$0]];
break;
case 157: case 159:
$$[$0-1].push($$[$0]);
break;
        }
    }
}

// Export module
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatParser = StatParser;


/* generated by @ts-jison/lexer-generator 0.4.1-aytm.3 */
const { JisonLexer } = require('@ts-jison/lexer');

class StatLexer extends JisonLexer {
    constructor (yy = {}) {
        super(yy);
        this.options = {"moduleName":"Stat"};
        this.rules = [
        /^(?:(?:\d{4}-[01]\d-[0-3]\d(?:T|\s+)[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:?[0-5]\d|Z)?)|(?:\d{4}-[01]\d-[0-3]\d(?:T|\s+)[0-2]\d:[0-5]\d:[0-5]\d(?:[+-][0-2]\d:?[0-5]\d|Z)?)|(?:\d{4}-[01]\d-[0-3]\d(?:T|\s+)[0-2]\d:[0-5]\d(?:[+-][0-2]\d:?[0-5]\d|Z)?))/,
        /^(?:\s+)/,
        /^(?:\()/,
        /^(?:\))/,
        /^(?:=)/,
        /^(?:<>|!=)/,
        /^(?:<=|&LT;=)/,
        /^(?:>=|&GT;=)/,
        /^(?:<|&LT;)/,
        /^(?:>|&GT;)/,
        /^(?:IN (?:SHAPE|CLUSTER)\b)/,
        /^(?:IN SECTION\b)/,
        /^(?:NOT IN\b)/,
        /^(?:IN\b)/,
        /^(?:LIKE\b)/,
        /^(?:NOT\b)/,
        /^(?:AND\b)/,
        /^(?:OR\b)/,
        /^(?:MIN\b)/,
        /^(?:MAX\b)/,
        /^(?:MINPOS(?:ITION)?\b)/,
        /^(?:MAXPOS(?:ITION)?\b)/,
        /^(?:COUNT\b)/,
        /^(?:SEEN\b)/,
        /^(?:CODEBOOK\b)/,
        /^(?:TAG\b)/,
        /^(?:(?:TRUE|FALSE)\b)/,
        /^(?:\d+(?:\.\d+)?\b)/,
        /^(?:"[^\"]*"|'[^\']*')/,
        /^(?:[PVX]Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:[PVX]Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:[PVX]Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)P\b)/,
        /^(?:[PVX]Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)PV\b)/,
        /^(?:[PVX]Q\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:[PVX]Q\d+RN\b)/,
        /^(?:[PVX]Q\d+A\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:[PVX]Q\d+A\d+RN\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)C\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)CV\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)P\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)PV\b)/,
        /^(?:Q\d+E\d+SQ\d+A\d+RC?\b)/,
        /^(?:Q\d+E\d+SQ\d+A\d+R\d+C?\b)/,
        /^(?:Q\d+E\d+SQ\d+A\d+R\d*C?V\b)/,
        /^(?:Q\d+E\d+SQ\d+A\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:Q\d+E\d+SQ\d+A\d+RN\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)C\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)CV\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)P\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)PV\b)/,
        /^(?:Q\d+E\d+SQ\d+RC\b)/,
        /^(?:Q\d+E\d+SQ\d+R\d+C?\b)/,
        /^(?:Q\d+E\d+SQ\d+R\d*C?V\b)/,
        /^(?:Q\d+E\d+SQ\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:Q\d+E\d+SQ\d+RN\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)C\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)CV\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)P\b)/,
        /^(?:[X]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)E(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)PV\b)/,
        /^(?:Q\d+E\d+RC\b)/,
        /^(?:Q\d+E\d+R\d+C?\b)/,
        /^(?:Q\d+E\d+R\d*CV\b)/,
        /^(?:Q\d+E\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:Q\d+E\d+RN\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)C\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)CV\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)P\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)PV\b)/,
        /^(?:[VX]?Q\d+SQ\d+A\d+I?\b)/,
        /^(?:[VX]?Q\d+SQ\d+A\d+RC\b)/,
        /^(?:[VX]?Q\d+SQ\d+A\d+R\d+C?\b)/,
        /^(?:[VX]?Q\d+SQ\d+A\d+R\d*C?V\b)/,
        /^(?:[VX]?Q\d+SQ\d+A\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:[VX]?Q\d+SQ\d+A\d+RN\b)/,
        /^(?:Q\d+SQ\d+A\d+R\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)C\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)CV\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)P\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)SQ(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)PV\b)/,
        /^(?:[VX]?Q\d+SQ\d+RC\b)/,
        /^(?:[VX]?Q\d+SQ\d+R\d+C?\b)/,
        /^(?:[VX]?Q\d+SQ\d+R\d*C?V\b)/,
        /^(?:[VX]?Q\d+SQ\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:[VX]?Q\d+SQ\d+RN\b)/,
        /^(?:[VX]?Q\d+SQ\d+(?:A\d+)?T\b)/,
        /^(?:[VX]?Q\d+SQ\d+V\b)/,
        /^(?:[VX]?Q\d+SQ\d+R\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)C\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)CV\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I?\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)P\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)A(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)PV\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)M\d+P\b)/,
        /^(?:Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)M\d+PV\b)/,
        /^(?:[VX]?Q\d+A\d+RC\b)/,
        /^(?:[VX]?Q\d+A\d+R\d+C?\b)/,
        /^(?:[VX]?Q\d+A\d+R\d*CV\b)/,
        /^(?:[VX]?Q\d+A\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:[VX]?Q\d+A\d+RN\b)/,
        /^(?:[VX]?Q\d+A\d+T\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)C\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)CV\b)/,
        /^(?:[VX]?Q(?:\d+[-:]\d+|(?:\d+\.)+\d+|(?:\d+,)+\d+|\d+)I\b)/,
        /^(?:[VX]?Q\d+RC\b)/,
        /^(?:[VX]?Q\d+R\d+P\b)/,
        /^(?:[VX]?Q\d+R\d+PV\b)/,
        /^(?:[VX]?Q\d+R\d+C?\b)/,
        /^(?:[VX]?Q\d+R\d*CV\b)/,
        /^(?:[VX]?Q\d+R\d*I(?:X|SX|XS|S)?\b)/,
        /^(?:[VX]?Q\d+RN\b)/,
        /^(?:[VX]?Q\d+T\b)/,
        /^(?:[VX]?Q\d+R(?:PV?)?\b)/,
        /^(?:P?Q\d+\w*)/,
        /^(?:NULL\b)/,
        /^(?:@?[A-Z][A-Z0-9_]*\b)/,
        /^(?:,)/,
        /^(?:[.])/,
        /^(?:[*])/,
        /^(?:[/])/,
        /^(?:[+])/,
        /^(?:-)/,
        /^(?:$)/
    ];
        this.conditions = {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127],"inclusive":true},"PARENTHESES":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127],"inclusive":true}};
    }
    performAction (yy, yy_, $avoiding_name_collisions, YY_START) {
              let YYSTATE = YY_START;
            switch ($avoiding_name_collisions) {
    case 0:return 46;
      break;
    case 1:/* skip whitespace */
      break;
    case 2:yy.lexer.pushState('PARENTHESES'); return 7;
      break;
    case 3:yy.lexer.popState(); return 8;
      break;
    case 4:return 22;
      break;
    case 5:return 24;
      break;
    case 6:return 17;
      break;
    case 7:return 18;
      break;
    case 8:return 19;
      break;
    case 9:return 20;
      break;
    case 10:return 33;
      break;
    case 11:return 34;
      break;
    case 12:return 27;
      break;
    case 13:return 26;
      break;
    case 14:return 28;
      break;
    case 15:return 13;
      break;
    case 16:return 11;
      break;
    case 17:return 12;
      break;
    case 18:return 51;
      break;
    case 19:return 52;
      break;
    case 20:return 53;
      break;
    case 21:return 54;
      break;
    case 22:return 55;
      break;
    case 23:return 14;
      break;
    case 24:return 41;
      break;
    case 25:return 36;
      break;
    case 26:return 9;
      break;
    case 27:return 42;
      break;
    case 28:return 56;
      break;
    case 29:return 10;
      break;
    case 30:return 10;
      break;
    case 31:return 58;
      break;
    case 32:return 43;
      break;
    case 33:return 58;
      break;
    case 34:return 43;
      break;
    case 35:return 58;
      break;
    case 36:return 43;
      break;
    case 37:return 58;
      break;
    case 38:return 43;
      break;
    case 39:return 10;
      break;
    case 40:return 58;
      break;
    case 41:return 43;
      break;
    case 42:return 58;
      break;
    case 43:return 58;
      break;
    case 44:return 43;
      break;
    case 45:return 58;
      break;
    case 46:return 43;
      break;
    case 47:return 58;
      break;
    case 48:return 43;
      break;
    case 49:return 10;
      break;
    case 50:return 58;
      break;
    case 51:return 43;
      break;
    case 52:return 58;
      break;
    case 53:return 58;
      break;
    case 54:return 43;
      break;
    case 55:return 58;
      break;
    case 56:return 43;
      break;
    case 57:return 58;
      break;
    case 58:return 43;
      break;
    case 59:return 10;
      break;
    case 60:return 58;
      break;
    case 61:return 43;
      break;
    case 62:return 58;
      break;
    case 63:return 58;
      break;
    case 64:return 43;
      break;
    case 65:return 58;
      break;
    case 66:return 43;
      break;
    case 67:return 58;
      break;
    case 68:return 43;
      break;
    case 69:return 10;
      break;
    case 70:return 58;
      break;
    case 71:return 43;
      break;
    case 72:return 10;
      break;
    case 73:return 58;
      break;
    case 74:return 58;
      break;
    case 75:return 43;
      break;
    case 76:return 58;
      break;
    case 77:return 43;
      break;
    case 78:return 62;
      break;
    case 79:return 58;
      break;
    case 80:return 43;
      break;
    case 81:return 10;
      break;
    case 82:return 58;
      break;
    case 83:return 43;
      break;
    case 84:return 58;
      break;
    case 85:return 58;
      break;
    case 86:return 43;
      break;
    case 87:return 58;
      break;
    case 88:return 43;
      break;
    case 89:return 58;
      break;
    case 90:return 43;
      break;
    case 91:return 62;
      break;
    case 92:return 58;
      break;
    case 93:return 43;
      break;
    case 94:return 10;
      break;
    case 95:return 58;
      break;
    case 96:return 43;
      break;
    case 97:return 58;
      break;
    case 98:return 43;
      break;
    case 99:return 58;
      break;
    case 100:return 58;
      break;
    case 101:return 43;
      break;
    case 102:return 58;
      break;
    case 103:return 43;
      break;
    case 104:return 58;
      break;
    case 105:return 10;
      break;
    case 106:return 58;
      break;
    case 107:return 43;
      break;
    case 108:return 10;
      break;
    case 109:return 58;
      break;
    case 110:return 58;
      break;
    case 111:return 43;
      break;
    case 112:return 58;
      break;
    case 113:return 43;
      break;
    case 114:return 58;
      break;
    case 115:return 43;
      break;
    case 116:return 58;
      break;
    case 117:return 62;
      break;
    case 118:return 35
      break;
    case 119:return 38;
      break;
    case 120: // Check if variable exists in yy.REFS_INFO
          if (!(yy_.yytext in yy.REFS_INFO) && !(yy_.yytext in yy.TYPES_INFO)) {
              return 38; // undefined ref is just TOKEN
          }
          // Create a token that includes type information
          this.yylval = {
              name: yy_.yytext,
              type: yy.REFS_INFO[yy_.yytext]
          };
          if( Object.hasOwn(yy.TYPES_INFO, yy_.yytext) )
            return yy.TYPES_INFO[yy_.yytext];

          // Return different tokens based on type
          switch(yy.REFS_INFO[yy_.yytext]) {
            case 'd':
            case 'n':
              return 45;
            case 't':
              return 38;
            case 'a':
              return 64;
            default:
              return 38;
          }
          
      break;
    case 121:return 40;
      break;
    case 122:return 37;
      break;
    case 123:return 49;
      break;
    case 124:return 50;
      break;
    case 125:return 48;
      break;
    case 126:return 47;
      break;
    case 127:return 5;
      break;
        }
    }
}


// Export module
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatLexer = StatLexer;

